import React, { Fragment, useCallback, useEffect, useState } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import clsx from "clsx"
import "../fragments"

import Language from "./common/language"
import { Dialog, Transition } from "@headlessui/react"
// import MobileMenuIcon from "./common/MobileMenuIcon"
import MobileMenuCloseIcon from "./common/MobileMenuCloseIcon"
import { SlArrowRight } from "react-icons/sl"
import AnimateHeight from "react-animate-height"

import LogoRewards from "../images/logo-rewards.svg"

export default function HeaderRewards({ slug, locale }) {
  const data = useStaticQuery(graphql`
    {
      allWordpressMenuLocation(
        filter: { location: { eq: "gatsby-header-menu" } }
      ) {
        nodes {
          menuData {
            items {
              title
              url
              slug
              child_items {
                title
                url
                slug
              }
            }
          }
          language
        }
      }
      wp {
        languages {
          code
          default_locale
          native_name
          translated_name
          is_hidden
        }
        themeGeneralSettings {
          themeSettings {
            logo {
              localFile {
                url
              }
            }
            logoWhite {
              localFile {
                url
              }
            }
          }
        }
      }
      allWordpressAcfOptions {
        nodes {
          language
          themeGeneralSettings {
            themeSettings {
              documentHeading
              documentExcerpt
              logo {
                mediaItemUrl
              }
              logoWhite {
                mediaItemUrl
              }
              startTrading {
                target
                title
                url
              }
              login {
                target
                title
                url
              }
            }
          }
        }
      }
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const currentLanguage = {
    en_US: "en",
    id_ID: "id",
    vi_VN: "vi",
    zh_CN: "zh",
  }[locale]

  const homeLink = {
    en_US: "/",
    id_ID: "/id/",
    vi_VN: "/vi/",
    zh_CN: "/zh/",
  }[locale]

  const menu = data.allWordpressMenuLocation.nodes.find(
    (node) => node.language === currentLanguage
  )

  const wordpressAcfOptions = data.allWordpressAcfOptions.nodes.find(
    (node) => node.language === currentLanguage
  )

  const logoDark = data.wp.themeGeneralSettings.themeSettings.logo.localFile.url
  // const logoLight =
  //   data.wp.themeGeneralSettings.themeSettings.logoWhite.localFile.url

  const startTrading =
    wordpressAcfOptions?.themeGeneralSettings.themeSettings.startTrading
  const login = wordpressAcfOptions?.themeGeneralSettings.themeSettings.login
  const siteTitle = data.site.siteMetadata.title
  const langs = data.wp.languages

  const [isScrolled, setIsScrolled] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isFrontPage, setIsFrontPage] = useState(slug === "rewards")
  const [showBackToTop, setShowBackToTop] = useState(false)

  // const openMenu = () => {
  //   setIsMenuOpen(true)
  // }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  const scrollHandler = useCallback(() => {
    setIsScrolled(window.scrollY > 50)
    if (window.scrollY > 200) {
      setShowBackToTop(true)
    } else {
      setShowBackToTop(false)
    }
  }, [])

  const toTop = () => {
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    setIsFrontPage(slug === "rewards")
    window.addEventListener("scroll", scrollHandler)

    return () => {
      window.removeEventListener("scroll", scrollHandler)
    }
  }, [scrollHandler, setIsFrontPage, slug])

  return (
    <>
      <header
        id="page-header"
        className={clsx(
          "inset-x-0 top-0 z-50 transition-colors fixed",
          isScrolled ? "bg-white shadow-xl" : "",
        )}
      >
        {/* <div className="container mx-auto xl:hidden relative h-[26px] justify-end gap-4 flex py-1 items-center border-b border-secondary/50 z-10">
          <Link
            href="/webtrader"
            target="_self"
            rel="noreferrer noopener"
            className="inline-flex items-center justify-center h-full text-xs font-normal leading-none capitalize rounded-lg font-heading min-w-fit hover:text-dark"
          >
            <span>Webtrader</span>
          </Link>
          <a
            href={login ? login.url : "#"}
            target={login ? login.target : "_self"}
            rel="noreferrer noopener"
            className="inline-flex items-center justify-center h-full text-xs font-normal leading-none capitalize rounded-lg font-heading min-w-fit hover:text-dark"
          >
            <span>{login ? login.title : "Login"}</span>
          </a>
          <div className="relative bottom-0 flex items-center h-full">
            <Language langs={langs} locale={locale} />
          </div>
        </div> */}
        <div className={
          clsx(
            "container relative flex items-center justify-between mx-auto h-[80px] transition-all",
            isScrolled ? "lg:h-[100px]" : "lg:h-[120px]",

          )
        }>
          <button type="button" onClick={toTop} className="flex items-center">
            <LogoRewards
              className={
                clsx(
                  "object-contain w-[188px] transition-all h-auto",
                  isScrolled ? "lg:w-[260px]" : "lg:w-[320px]",
                )
              }
              alt="Prospero Rewards Logo"
              width="236"
              height="53"
            />
            <span className="sr-only">{siteTitle}</span>
          </button>

          <Link to={homeLink} className="flex items-center text-xs sm:text-sm">
            &lt; Back to main website
          </Link>
        </div>
      </header>

      <button
        type="button"
        onClick={toTop}
        className={clsx(
          "fixed z-30 w-10 transition-all duration-300 bg-white rounded-full cursor-pointer text-secondary md:w-14 md:hover:-translate-y-2 right-5 max-md:bottom-5 md:top-1/2",
          showBackToTop ? "block" : "hidden"
        )}
      >
        <span className="sr-only">Back to Top</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 68.78 68.78"
          className="w-full"
        >
          <circle
            cx="34.39"
            cy="34.39"
            r="33.89"
            fill="none"
            stroke="currentColor"
          />
          <path
            fill="currentColor"
            d="M34.33,20.37c-.46,0-.89,.19-1.22,.52l-12.3,12.28c-.33,.33-.52,.78-.52,1.25,0,.47,.19,.92,.52,1.25,.33,.33,.78,.52,1.25,.52,.47,0,.92-.19,1.25-.52l9.29-9.29v20.33h0c.01,.62,.35,1.18,.89,1.49,.54,.31,1.2,.31,1.73,0,.54-.31,.88-.87,.89-1.49V26.35l9.29,9.29h0c.32,.37,.78,.59,1.27,.61,.49,.02,.96-.17,1.31-.51,.35-.35,.53-.82,.51-1.31-.02-.49-.24-.95-.61-1.27l-12.27-12.28c-.34-.34-.8-.52-1.27-.52h0Z"
          />
        </svg>
      </button>
    </>
  )
}

function MobileMenuItem({ menuItem, onClick }) {
  const [height, setHeight] = useState(0)

  const hasChildren =
    !menuItem.child_items || menuItem.child_items.length === 0 ? false : true

  return (
    <div>
      {hasChildren ? (
        <>
          <button
            aria-expanded={height !== 0}
            onClick={() => setHeight(height === 0 ? "auto" : 0)}
          >
            <div className="flex items-center gap-3 text-xl font-semibold text-left">
              <span>{menuItem.title}</span>
              <SlArrowRight
                className={clsx(
                  "text-primary transition-transform w-4 h-4 shrink-0",
                  height === 0 && "rotate-90"
                )}
              />
            </div>
          </button>
          <AnimateHeight duration={300} height={height}>
            <div className="pt-5 pb-3">
              <MobileNestedMenu
                childItems={menuItem.child_items}
                onClick={onClick}
              />
            </div>
          </AnimateHeight>
        </>
      ) : (
        <>
          {menuItem.url.startsWith("http") ? (
            <a
              href={menuItem.url}
              rel="noreferrer noopener"
              onClick={onClick}
              className="text-xl font-semibold text-left"
            >
              <span>{menuItem.title}</span>
            </a>
          ) : (
            <Link
              to={menuItem.url}
              onClick={onClick}
              className="text-xl font-semibold text-left"
            >
              <span>{menuItem.title}</span>
            </Link>
          )}
        </>
      )}
    </div>
  )
}

function MobileNestedMenu({ childItems, onClick }) {
  if (!childItems || childItems.length === 0) return null

  return (
    <div className="flex flex-col gap-3 ml-4 text-lg">
      {childItems.map((child, index) => {
        return (
          <div key={`${child.url}-${index}`}>
            {child.url.startsWith("http") ? (
              <a href={child.url} rel="noreferrer noopener" onClick={onClick}>
                {child.title}
              </a>
            ) : (
              <Link to={child.url} onClick={onClick}>
                {child.title}
              </Link>
            )}
          </div>
        )
      })}
    </div>
  )
}
